﻿import React, { useContext, useState, useCallback, useEffect } from 'react';
import { setSearchHistory } from '../../../../../Resources/Scripts/_Shared/history';
import AdvFiltersWidget from './AdvFilters';
import { DateSelectionWithLabel } from '../../../../../Resources/Scripts/_Shared/elements/DateSelectionWithLabel'

const ControlsWidget = ({ children, facilitySearchContext, setFacilitySearchContext, viewToggle, setViewToggle }) => {
  
  const lang = { ...facilitySearchContext.localization.inputs, ...facilitySearchContext.episerver };

  const showOnMapHandler = () => setFacilitySearchContext({ ...facilitySearchContext, mapViewOpen: !facilitySearchContext.mapViewOpen });
  const filterHandler = () => setFacilitySearchContext({ ...facilitySearchContext, filtersOpen: true });
  const language = facilitySearchContext.episerver.selectedlanguage;
  const selectedLanguage = language === 'no' ? 'nb' : language === 'se' ? 'sv' : language;
  let activeFilter = false;
  const advSearch = !document.querySelector('.simple-search');

  for (const [key] of Object.entries(facilitySearchContext.filterSelection)) {
    if (key !== 'ParkingSpaceTypeSelection' && facilitySearchContext.filterSelection[key]) activeFilter = true;
  }
  for (const [key] of Object.entries(facilitySearchContext.filterSelection.ParkingSpaceTypeSelection)) {
    if (facilitySearchContext.filterSelection.ParkingSpaceTypeSelection[key]) activeFilter = true;
  }

  return (
    <div className="facilitysearchpage__controls">
      <div className={facilitySearchContext.customerService ? "facilitysearchpage__controls__inner facilitysearchpage__controls__inner--wide" : "facilitysearchpage__controls__inner"}>
        {children}
        {!advSearch && 
            <button 
                onClick={filterHandler} 
                className={activeFilter ? "facilitysearchpage__control--filter active" : "facilitysearchpage__control--filter"} 
                disabled={facilitySearchContext.showLoadingScreen}
            >
                <span>
                    {lang.filter}
                </span>
            </button>}
      </div>
      {advSearch && facilitySearchContext.isSearchButtonDisabled === false && (
        <div className="facilitysearchpage__advfilters" >
            <AdvFiltersWidget
                facilitySearchContext={facilitySearchContext}
                setFacilitySearchContext={setFacilitySearchContext}
            />
        </div>
      )}
      {facilitySearchContext.selectedLocation && <div className="facilitysearchpage__controls__switch">
        <button onClick={(e) => { setViewToggle('list'); e.currentTarget.blur() }} className={viewToggle === 'list' ? 'active' : ''}>
          <span>
            {lang.listview}
          </span>
        </button>
        <button onClick={(e) => { setViewToggle('map'); e.currentTarget.blur() }} className={viewToggle === 'map' ? 'active' : ''}>
          <span>
            {lang.mapview}
          </span>
        </button>
      </div>}
    </div>
  )
}

export default ControlsWidget;
